import { Box, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const HeaderContainer = styled(Box)`
  border-bottom: ${({ theme }) =>
    `1px solid ${getThemeColor('grey_5', theme)}`};
`
